<!--
ICONA LUCCHETTO
-->
<div class="layout horizontal center middle" style="width: 100%; height: 120px; margin-bottom: 16px;">
    <app-flipping-logo height="120px" 
                        width="120px"
            frontImage="./assets/images/login.svg"
            frontImageHeight="100px">
    </app-flipping-logo>
</div>

<!--
LINK VERSO SET-PASSWORD
-->
<p *ngIf="passwordSettingExpected" [innerHtml]="'LOGIN.SET_PASSWORD'|translate"></p>

<!--
LINK VERSO SIGN-UP
-->
<p *ngIf="signUpExpected" [innerHtml]="'LOGIN.SIGN_UP'|translate"></p>

<!--
FORM
-->
<app-form-field #usernameFormField type="EMAIL" [label]="'LOGIN.USERNAME'|translate"
                [settings]="settings.fieldsSettings.username"
                [value]="valuesForInput.username"
                (modelChange)="updateCurrentValue('username',$event)"
                [specifiedAttributes]="specifiedAttributes.username"
                (enterPressure)="submit()">
</app-form-field>
<app-form-field #passowrdFormField type="PASSWORD" [label]="'LOGIN.PASSWORD'|translate"
                [settings]="settings.fieldsSettings.password"
                [value]="valuesForInput.password"
                (modelChange)="updateCurrentValue('password',$event)"
                [specifiedAttributes]="specifiedAttributes.password"
                (enterPressure)="submit()">
</app-form-field>
<!--
RECAPTCHA
-->
<div class="layout horizontal center middle" *ngIf="requireRecaptcha" style="margin-bottom: 20px;">
    <re-captcha #reCaptcha style="margin-top: 6px;"
        (resolved)="recaptchaToken=$event"
        (error)="onError($event)"
        errorMode="handled"
        siteKey="6Lfom9AaAAAAABwNzIgDQb90pw70CKm7boaKeKoB">
    </re-captcha>
</div>

<!--
LINK VERSO RESET-PASSWORD
-->
<div class="layout horizontal right middle" style="margin-bottom: 15px">
    <span class="link" (click)="resetPassword()">{{'LOGIN.RESET_PASSWORD'|translate}}</span>
</div>

<!--
BOTTONI
-->
<div class="layout horizontal space-between">
    <app-button-set align="left">
        <app-button [label]="'CANCEL'|translate" icon="arrow-left" (click)="cancel()" 
                    [disabled]="formSubmitting"></app-button>
    </app-button-set>
    <app-button-set align="right">
        <app-button [label]="'LOGIN.ACCESS'|translate" primary="true" icon="login" [action]="submit.bind(this)" 
                    [disabled]="someErrors || formSubmitting"></app-button>
    </app-button-set>
</div>
